import { createAction } from 'redux-actions';

const actions = {
  /**
   * [유저] 유저 데이터 변경하기
   */
  SET_DATA: 'account/user/SET_DATA',
  setData: createAction('account/user/SET_DATA'),

  /**
   * [유저] 모달 토글
   */
  TOGGLE_MODAL: 'account/user/TOGGLE_MODAL',
  userToggleModal: createAction('account/user/TOGGLE_MODAL'),

  /**
   * [유저] 유저 리스트 요청하기
   */
  GET_USER_LIST_REQUEST: 'account/user/GET_USER_LIST_REQUEST',
  GET_USER_LIST_SUCCESS: 'account/user/GET_USER_LIST_SUCCESS',
  getAccountUserList: createAction('account/user/GET_USER_LIST_REQUEST'),

  /**
   * [유저] 유저 excel 리스트 다운로드 하기
   */
  GET_USER_EXCEL_DOWNLOAD_REQUEST: 'account/user/GET_USER_EXCEL_DOWNLOAD_REQUEST',
  GET_USER_EXCEL_DOWNLOAD_SUCCESS: 'account/user/GET_USER_EXCEL_DOWNLOAD_SUCCESS',
  getAccountUserExcelDownload: createAction('account/user/GET_USER_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [유저] 유저 랭킹 리스트 요청하기
   */
  GET_USER_RANK_LIST_REQUEST: 'account/user/GET_USER_RANK_LIST_REQUEST',
  GET_USER_RANK_LIST_SUCCESS: 'account/user/GET_USER_RANK_LIST_SUCCESS',
  getAccountUserRankList: createAction('account/user/GET_USER_RANK_LIST_REQUEST'),

  /**
   * [유저] 유저 랭킹 excel 다운로드 하기
   */
  GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST: 'account/user/GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST',
  GET_USER_RANK_EXCEL_DOWNLOAD_SUCCESS: 'account/user/GET_USER_RANK_EXCEL_DOWNLOAD_SUCCESS',
  getAccountUserRankExcelDownload: createAction('account/user/GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [유저] 유저 상세 정보 중 태그 타임라인 리스트 요청하기
   */
  GET_USER_DETAIL_TAG_LOG_LIST_REQUEST: 'account/user/GET_USER_DETAIL_TAG_LOG_LIST_REQUEST',
  getAccountUserDetailTagLogList: createAction('account/user/GET_USER_DETAIL_TAG_LOG_LIST_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급 요청하기
   */
  GENERATE_COUPON_SUCCESS: 'account/user/GENERATE_COUPON_SUCCESS',

  /**
   * [포인트 발급 모달] 포인트 발급 하기
   */
  GENERATE_POINT_SUCCESS: 'account/user/GENERATE_POINT_SUCCESS',
};

export default actions;
